import React, { useEffect, useState } from 'react'
import axios from 'axios'

import { Container, Offcanvas, Row, Col, Image, Modal } from 'react-bootstrap'
import CustomButton from '../button'

//svg
import { ReactComponent as ArrowLeft } from '../../static/images/svg/Arrow left.svg'

//components
import DetailsTable from '../table'
import SpinnerComp from '../spinner'
const OffCanvasComp = ({
	placement,
	show,
	setShow,
	orderItem,
	name,
	token,
  role
}) => {

  const [canvasWidth, setCanvasWidth] = useState('40%');
  const [showImageModal, setShowImageModal] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(true);

  useEffect(() => {
    
    const updateCanvasWidth = () => {
      if (window.innerWidth <= 768) {
        setCanvasWidth('90%'); // Mobile view
      } else {
        setCanvasWidth('40%'); // Desktop view
      }
    };

    // Set initial width
    updateCanvasWidth();

    // Listen for resize events
    window.addEventListener('resize', updateCanvasWidth);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('resize', updateCanvasWidth);
    };
  }, []);

	const [loading,setLoading] = useState(true)
	const [OrderProducts,setOrderProducts] = useState([])

	const upDate = new Date(orderItem.updatedAt)
	const utcUpDate = upDate.toLocaleString('en-US', { timeZone: 'UTC' })
	const localUpDate = upDate.toLocaleString('en-GB', { timeZone: 'Asia/Dubai' })
	const createdDate = new Date(orderItem.createdAt)
	const utcDate = createdDate.toLocaleString('en-US', { timeZone: 'UTC' })
	const localDate = createdDate.toLocaleString('en-GB', { timeZone: 'Asia/Dubai' })

	


	return (
		<>
			
				
			<Offcanvas show={show} onHide={() => setShow(false)} placement={placement} style={{ width: canvasWidth }}>
  <Offcanvas.Body>
    <Container fluid className="pt-0 p-3">
      {/* Header */}
      <div className="d-flex align-items-center" style={{ color: '#005A9C' }}>
        <ArrowLeft onClick={() => setShow(false)} style={{ cursor: 'pointer', marginRight: '10px' }} />
        <h3 className="ms-1" style={{ fontFamily: 'Arial, sans-serif', fontWeight: 'bold' }}>Shipment Details</h3>
      </div>
      <hr />
      <div className="row justify-content-center align-items-center text-black pe-5" style={{ minHeight: "350px" }}>
        <div className="col-auto text-center">
          {orderItem.image ? (
            <>
              {isImageLoading && (
                <div
                  style={{
                    height: "350px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <SpinnerComp />
                </div>
              )}
              <Image
                src={orderItem.image}
                alt="Shipment"
                style={{
                  height: "350px",
                  objectFit: "contain",
                  display: isImageLoading ? "none" : "block", // Hide image until loaded
                }}
                onLoad={() => setIsImageLoading(false)} // Hide spinner when image loads
                onError={() => setIsImageLoading(false)} // Handle error cases
                onClick={() => setShowImageModal(true)}
              />
            </>
          ) : (
            <div
              style={{
                height: "350px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#555", // Optional text color
                fontSize: "1.5rem",
                fontWeight: "bold",
              }}
            >
              No Image Found
            </div>
          )}
        </div>
      </div>

        <hr/>
      {/* Details Card */}
      <div
        className="p-4 shadow-sm rounded"
        style={{
          backgroundColor: '#f9f9f9',
          border: '1px solid #ddd',
          fontFamily: 'Arial, sans-serif',
        }}
      >
        
        <table className="table table-borderless">
          <tbody>

            <tr>
              <th style={{ color: '#005A9C', width: '30%' }}>Barcode #:</th>
              <td>{orderItem.shipmentId}</td>
            </tr>
            <tr>
              <th style={{ color: '#005A9C', width: '30%' }}>Sender Company:</th>
              <td>{orderItem.senderName}</td>
            </tr>
            <tr>
              <th style={{ color: '#005A9C', width: '30%' }}>Receiver Name:</th>
              <td>{orderItem.receiverName}</td>
            </tr>
            <tr>
              <th style={{ color: '#005A9C', width: '30%' }}>Receiver Phone:</th>
              <td>+{orderItem.phoneNumber}</td>
            </tr>
            <tr>
              <th style={{ color: '#005A9C', width: '30%' }}>Receiver Address:</th>
              <td>{orderItem.address}</td>
            </tr>
            <tr>
              <th style={{ color: '#005A9C', width: '30%' }}>Charges:</th>
              <td>{orderItem.charges}</td>
            </tr>
			      <tr>
              <th style={{ color: '#005A9C', width: '30%' }}>Date Created:</th>
              <td>{localDate}</td>
            </tr>
            <tr>
              <th style={{ color: '#005A9C', width: '30%' }}>Last Update:</th>
              <td>{localUpDate}</td>
            </tr>
            <tr>
              <th style={{ color: '#005A9C', width: '30%' }}>Shipment Status:</th>
              <td>{orderItem.status}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <hr />
      <div className="text-center mt-3">
        {role !== 'admin' && (
          <p style={{ fontStyle: 'italic', color: '#777' }}>
            For further queries, contact our support team at <a href="mailto:support@example.com" style={{ color: '#005A9C' }}>admin@falcondelivery.ae</a>.
          </p>
        )}
      </div>
    </Container>
  </Offcanvas.Body>
</Offcanvas>

								      {/* Image Modal */}
                      <Modal show={showImageModal} onHide={() => setShowImageModal(false)} size="lg" centered>
        <Modal.Body className="text-center">
          <Image
            src={orderItem.image}
            alt="Shipment Large View"
            style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          />
        </Modal.Body>
        <Modal.Footer>
          <CustomButton
            variant="danger"
            onClick={() => setShowImageModal(false)}
          >
            Close
          </CustomButton>
        </Modal.Footer>
      </Modal>
			
		</>
	)
}

export default OffCanvasComp